// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/profile.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/profile.proto.
 */
export const file_travplaces_v1_profile: GenFile = /*@__PURE__*/
  fileDesc("Cht0cmF2cGxhY2VzL3YxL3Byb2ZpbGUucHJvdG8SDXRyYXZwbGFjZXMudjEiRwoVQ2hhbmdlUGFzc3dvcmRSZXF1ZXN0EhgKEGN1cnJlbnRfcGFzc3dvcmQYASABKAkSFAoMbmV3X3Bhc3N3b3JkGAIgASgJIikKFkNoYW5nZVBhc3N3b3JkUmVzcG9uc2USDwoHdXBkYXRlZBgBIAEoCDKhAQoOUHJvZmlsZVNlcnZpY2USjgEKDkNoYW5nZVBhc3N3b3JkEiQudHJhdnBsYWNlcy52MS5DaGFuZ2VQYXNzd29yZFJlcXVlc3QaJS50cmF2cGxhY2VzLnYxLkNoYW5nZVBhc3N3b3JkUmVzcG9uc2UiL4rqMAMKASqQ6jACmuowEGN1cnJlbnRfcGFzc3dvcmSa6jAMbmV3X3Bhc3N3b3JkQqcBChFjb20udHJhdnBsYWNlcy52MUIMUHJvZmlsZVByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * ChangePasswordRequest carries both passwords. The account is not named: it
 * is whoever the request is authenticated as, so there is no field an attacker
 * could point at somebody else's account.
 *
 * @generated from message travplaces.v1.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"travplaces.v1.ChangePasswordRequest"> & {
  /**
   * @generated from field: string current_password = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message travplaces.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_profile, 0);

/**
 * @generated from message travplaces.v1.ChangePasswordResponse
 */
export type ChangePasswordResponse = Message<"travplaces.v1.ChangePasswordResponse"> & {
  /**
   * @generated from field: bool updated = 1;
   */
  updated: boolean;
};

/**
 * Describes the message travplaces.v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema: GenMessage<ChangePasswordResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_profile, 1);

/**
 * ProfileService is what an operator may do to their own account.
 *
 * Separate from AdminUserService because it is not an administrative act:
 * changing your own password requires no authority over anyone, and an
 * operator locked out of doing it is stuck with whatever password they were
 * handed. The seeded account's password is published in this repository, so
 * somebody has to be able to change it without a database console.
 *
 * @generated from service travplaces.v1.ProfileService
 */
export const ProfileService: GenService<{
  /**
   * ChangePassword replaces the caller's own password, after checking the
   * current one.
   *
   * @generated from rpc travplaces.v1.ProfileService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof ChangePasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_profile, 0);

